import { Link, useLocation } from 'react-router-dom';
import { Navbar, Container } from 'react-bootstrap';
import {
  FaTachometerAlt,
  FaUsers,
  FaCalendarAlt,
  FaTrophy,
  FaMapMarkerAlt,
  FaCoins,
  FaBox,
  FaChartBar,
  FaCog,
  FaSignOutAlt
} from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';

const AdminTopNavbar = () => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  const menuItems = [
    {
      path: '/admin',
      label: 'Dashboard',
      icon: FaTachometerAlt,
      exact: true
    },
    {
      path: '/admin/users',
      label: 'Usuarios',
      icon: FaUsers
    },
    {
      path: '/admin/temporadas',
      label: 'Temporadas',
      icon: FaCalendarAlt
    },
    {
      path: '/admin/matches',
      label: 'Torneos',
      icon: FaTrophy
    },
    {
      path: '/admin/venues',
      label: 'Sedes',
      icon: FaMapMarkerAlt
    },
    {
      path: '/admin/achievements',
      label: 'Propoints',
      icon: FaCoins
    },
    {
      path: '/admin/products',
      label: 'Productos',
      icon: FaBox
    },
    {
      path: '/admin/reports',
      label: 'Informes',
      icon: FaChartBar
    },
    {
      path: '/admin/settings',
      label: 'Configuración',
      icon: FaCog,
      adminOnly: true
    }
  ];

  return (
    <Navbar
      bg="dark"
      variant="dark"
      className="admin-top-navbar shadow-sm"
      fixed="top"
    >
      <Container fluid>
        {/* Brand */}
        <Navbar.Brand as={Link} to="/admin" className="fw-bold">
          <span className="text-primary">ProKids</span>App
          <small className="ms-2 text-muted d-none d-sm-inline">Admin</small>
        </Navbar.Brand>

        {/* Navigation Menu - Grid Layout */}
        <div className="admin-navbar-nav w-100">
          {/* Main Navigation Grid */}
          <div className="admin-nav-grid">
            {menuItems.map((item) => {
              // Filtrar items solo para admin si es necesario
              if (item.adminOnly && user?.role !== 'admin') {
                return null;
              }

              const IconComponent = item.icon;
              const active = item.exact
                ? location.pathname === item.path
                : isActive(item.path);

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`admin-nav-icon ${active ? 'active' : ''}`}
                  title={item.label}
                >
                  <IconComponent size={18} />
                  <span className="nav-label">{item.label}</span>
                </Link>
              );
            })}

            {/* User Profile Icon */}
            <Link
              to="/admin/profile"
              className={`admin-nav-icon ${isActive('/admin/profile') ? 'active' : ''}`}
              title="Mi Perfil"
            >
              <div className="user-avatar-small">
                {(user?.name || 'A').charAt(0).toUpperCase()}
              </div>
              <span className="nav-label">Perfil</span>
            </Link>

            {/* Logout Icon */}
            <button
              onClick={handleLogout}
              className="admin-nav-icon logout-icon"
              title="Cerrar Sesión"
            >
              <FaSignOutAlt size={18} />
              <span className="nav-label">Salir</span>
            </button>
          </div>
        </div>
      </Container>
    </Navbar>
  );
};

export default AdminTopNavbar;
